<template>
  <div>
    <div class="pdf-preview" v-if="pdfFile">
      <button @click.self="closePreview()">
        &times;
    </button>

    <iframe
      :src="pdfFile"
      width="100%"
      height="100%"
    />
    </div>
    <div v-show="false">
      <div ref="testHtml">
        <div v-for="(item, index) in flattenArray"
                :key="item.id" class="mx-5 my-4">
          <div class="pdf-item mb-3 d-flex text-sm justify-content-between">
              <div>
                <img
                  src="../assets/gunter_Logo-bg.png"
                  alt="Logo"
                  style="flex: none;"
                  height="60"
                  width="60"
                />
              </div>
                <div class="text-2xl font-weight-bold" style="line-height: 1;">
                  {{ response.pickupDetails.address.toUpperCase() }}
                  <br>
                  {{ response.pickupDetails.city.toUpperCase() }},
                  {{ response.pickupDetails.state.toUpperCase() }}
                  {{ response.pickupDetails.zipCode }}
                  <br>
                  Tel: {{ response.agent.phone }}
                </div>
          </div>
          <!-- <div class="pdf-item mb-2"> -->
            <table class="table table-bordered text-xl w-100" style="line-height: 1;">
              <tr>
                <th colspan = "2">Shipper</th>
              </tr>
              <tr>
                <td class="text-5xl font-weight-bold" colspan = "2">
                  {{ response.shipper.firstName.toUpperCase() }}
                   {{ response.shipper.lastName.toUpperCase() }}
                </td>
              </tr>
            <!-- </table>
            <table class="table table-bordered text-xl w-100" style="line-height: 1;"> -->
              <tr>
                <th colspan = "2">Consignee</th>
              </tr>
              <tr>
                <td class="text-5xl font-weight-bold" colspan = "2">
                  <span>{{ response.consignee.firstName.toUpperCase() }}
                   {{ response.consignee.lastName.toUpperCase() }}</span>
                  <br/>
                  {{ response.consignee.address.toUpperCase() }}
                  <br/>
                  {{ response.consignee.city.toUpperCase() }},
                  {{ response.consignee.state.toUpperCase() }}
                  {{ response.consignee.zipCode }}
                </td>
              </tr>
            <!-- </table> -->
          <!-- </div> -->
          <!-- <div class="pdf-item mt-4 mb-2 text-center"> -->
            <!-- <table class="table table-bordered text-xl w-100 font-weight-bold"
            style="line-height: 1;"> -->
              <tr>
                <td class="text-5xl font-weight-bold text-center" colspan = "2">
                  {{ item.weight }} LBS
                  {{ item.length }} x {{ item.width }} x {{ item.height }}
                  ({{index + 1}} / {{ totalPackage }})
                </td>
              </tr>
              <tr>
                <td class="text-6xl font-weight-bold text-center" colspan = "2">
                  {{ response.id }}
                </td>
              </tr>
            <!-- </table> -->
          <!-- </div> -->
          <!-- <div class="pdf-item mb-2"> -->
            <!-- <table class="table table-bordered text-xl w-100 font-weight-bold text-center"
            style="line-height: 1;"> -->
                <tr class="font-weight-bold text-center">
                  <th>Destination</th>
                  <th>Route/Agent</th>
                </tr>
                <tr class="font-weight-bold text-center">
                  <td class="text-6xl">
                    {{ response.consignee.airportCode.toUpperCase() }}
                  </td>
                  <td class="text-5xl">
                    {{ response.agent.firstName.toUpperCase() }}
                     {{ response.agent.lastName.toUpperCase() }}
                  </td>
                </tr>
            <!-- </table> -->
          <!-- </div> -->
          <!-- <div class="pdf-item mb-2">
            <table class="table table-bordered text-xl w-100"> -->
                <tr>
                  <th colspan = "2">
                    <div class="d-flex justify-content-between">
                      <div>Service</div>
                      <div>{{ response.pickupDetails.pickupStartTime }}</div>
                    </div>
                  </th>
                </tr>
                <tr>
                  <td class="text-6xl font-weight-bold" colspan = "2">
                    <div v-if="response.itemDetails.travelMode">
                      {{ travelMode(response.itemDetails.travelMode).toUpperCase() }}
                    </div>
                    <div v-else>
                      {{ travelMode(response.itemDetails.travelMode) }}
                    </div>
                    <div class="pdf-item mb-3 d-flex justify-content-between">
                    <div>
                      <!-- <img
                        src="../assets/QR.png"
                        alt="Logo"
                        style="flex: none;"
                        height="120"
                        width="120"
                      /> -->
                      <VueQRCodeComponent :text="`https://gunter.soonforward.us/#/UpdateShipmentStatus/${item.id}`" error-level="L" :size="120"></VueQRCodeComponent>
                      </div>
                      <div>
                      ({{index + 1}} / {{ totalPackage }})
                      </div>
                    </div>
                    <div class="text-xs">
                      {{ currentUser.firstName.toUpperCase() }}
                      {{ currentUser.lastName.toUpperCase() }}
                    </div>
                  </td>
                </tr>
            </table>
          <!-- </div> -->
          <div v-if="index < flattenArray.length - 1 " class="html2pdf__page-break" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js';
import VueQRCodeComponent from 'vue-qrcode-component';

export default {
  name: 'BOLReceipt',
  props: [
    'name',
    'response',
    'currentUser',
  ],
  data() {
    return {
      pdfFile: null,
      seen: {},
      travelModes: [
        { value: null, text: '' },
        { value: 'oceanDirect', text: 'Ocean Direct' },
        { value: 'oceanTranshipment ', text: 'Ocean Transshipment' },
        { value: 'air', text: 'Air' },
        { value: 'ground', text: 'Ground' },
      ],
    };
  },
  computed: {
    hazardous() {
      const validItem = this.response.itemDetails.items.filter((item) => item.flag === true);
      return validItem.reduce((acc, item) => acc || item.hazardous, false);
    },
    totalPackage() {
      const validItem = this.response.itemDetails.items.filter((item) => item.flag === true);
      return validItem.reduce((acc, curr) => acc + curr.qty, 0);
    },
    flattenArray() {
      const validItem = this.response.itemDetails.items.filter((item) => item.flag === true);
      const flat = validItem.flatMap(({ seal, ...rest }) => seal.map((o) => ({
        ...rest,
        ...o,
      })));
      return flat;
    },
    // filteredArr() {
    //   this.reset();
    //   const filter = this.response.itemDetails.items.filter((el) => {
    //     if (el.packageType === '') {
    //       return false;
    //     }
    //     const duplicate = this.seen[el.packageType] !== undefined;
    //     if (duplicate) {
    //       this.seen[el.packageType] += 1;
    //     } else {
    //       this.seen[el.packageType] = 1;
    //     }
    //     return !duplicate;
    //   });
    //   return filter;
    // },

    // filteredArr() {
    //   const result = [];
    //   this.response.itemDetails.items.forEach((item) => {
    //     const resObj = result.find((obj) => obj.packageType === item.packageType
    //       && obj.length === item.length && obj.width === item.width
    //       && obj.height === item.height && obj.weight === item.weight);
    //     if (resObj) {
    //       resObj.count += 1;
    //     } else {
    //       result.push({ ...item, count: 1 });
    //     }
    //   });
    //   return result;
    // },

    // upperArr() {
    //   return this.upper(this.response);
    // },
  },
  methods: {
    // lower(response) {
    //   const copy = Object.keys(response).reduce((acc, curr) => {
    //     if (response[curr] == null) {
    //       acc[curr] = response[curr];
    //     } else if (typeof response[curr] === 'string') {
    //       acc[curr] = response[curr].toLowerCase().trim();
    //     } else if (Array.isArray(response[curr])) {
    //       acc[curr] = this.arrayLower(response[curr]);
    //     } else if (typeof response[curr] === 'object') {
    //       acc[curr] = this.lower(response[curr]);
    //     } else {
    //       acc[curr] = response[curr];
    //     }
    //     return acc;
    //   }, {});
    //   return copy;
    // },
    // arrayLower(response) {
    //   const copy = Object.keys(response).reduce((acc, curr) => {
    //     if (response[curr] == null) {
    //       acc[curr] = response[curr];
    //     } else if (typeof response[curr] === 'string') {
    //       acc[curr] = response[curr].toLowerCase().trim();
    //     } else if (Array.isArray(response[curr])) {
    //       acc[curr] = this.arrayLower(response[curr]);
    //     } else if (typeof response[curr] === 'object') {
    //       acc[curr] = this.lower(response[curr]);
    //     } else {
    //       acc[curr] = response[curr];
    //     }
    //     return acc;
    //   }, []);
    //   return copy;
    // },

    // upper(response) {
    //   const copy = Object.keys(response).reduce((acc, curr) => {
    //     if (response[curr] == null) {
    //       acc[curr] = response[curr];
    //     } else if (typeof response[curr] === 'string') {
    //       acc[curr] = response[curr].toUpperCase();
    //     } else if (Array.isArray(response[curr])) {
    //       acc[curr] = this.arrayUpper(response[curr]);
    //     } else if (typeof response[curr] === 'object') {
    //       acc[curr] = this.upper(response[curr]);
    //     } else {
    //       acc[curr] = response[curr];
    //     }
    //     return acc;
    //   }, {});
    //   return copy;
    // },
    // arrayUpper(response) {
    //   const copy = Object.keys(response).reduce((acc, curr) => {
    //     if (response[curr] == null) {
    //       acc[curr] = response[curr];
    //     } else if (typeof response[curr] === 'string') {
    //       acc[curr] = response[curr].toUpperCase();
    //     } else if (Array.isArray(response[curr])) {
    //       acc[curr] = this.arrayUpper(response[curr]);
    //     } else if (typeof response[curr] === 'object') {
    //       acc[curr] = this.upper(response[curr]);
    //     } else {
    //       acc[curr] = response[curr];
    //     }
    //     return acc;
    //   }, []);
    //   return copy;
    // },
    travelMode(value) {
      const type = this.travelModes.find((mode) => mode.value === value);
      if (type) {
        return type.text;
      }
      return '';
    },
    currentDateTime() {
      const today = new Date();
      return today.toLocaleDateString('en-US');
      // need to update
    },
    reset() {
      this.seen = {};
    },
    closePreview() {
      this.pdfFile = null;
    },
    generatePdf() {
      /* eslint new-cap: ["error", { "newIsCap": false }] */
      // const doc = new jsPDF('p', 'pt', 'A4');
      // const margins = {
      //   top: 80,
      //   bottom: 60,
      //   left: 40,
      //   width: 522,
      // };

      // doc.html(this.$refs.testHtml, { left: margins.left, width: margins.width }).then(() => {
      //   doc.output('dataurlnewwindow');
      // });

      const opt = {
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          dpi: 600,
          scale: 1,
        },
      };

      html2pdf().from(this.$refs.testHtml).set(opt).output('bloburl')
        .then((ref) => {
          this.pdfFile = ref;
        });
    },
  },
  // mounted() {
  //   profile().then((resp) => {
  //     this.firstName = resp.data.result.firstName;
  //     this.lastName = resp.data.result.lastName;
  //   }).catch((err) => {
  //     console.log(err);
  //   });
  // },
  filters: {
    toCurrency(value) {
      if (typeof value !== 'number') {
        return value;
      }
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
      });
      return formatter.format(value);
    },
  },
  components: {
    VueQRCodeComponent,
  },
};
</script>

<style lang="scss" scoped>
 body {
  font-family: Helvetica;
}
li:not(:last-child) {
    margin-bottom: 5px;
}
.table-bordered td, .table-bordered th {
  border: 1px solid #343434;
}

.pdf-preview {
  position: fixed;
  width: 65%;
  min-width: 600px;
  height: 80vh;
  top: 100px;
  z-index: 9999999;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 5px;
  box-shadow: 0px 0px 10px #00000048;

  button {
    position: absolute;
    top: -20px;
    left: -15px;
    width: 35px;
    height: 35px;
    background: #555;
    border: 0;
    box-shadow: 0px 0px 10px #00000048;
    border-radius: 50%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    cursor: pointer;
  }

  iframe {
    border: 0;
  }
}

</style>
